import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextButton } from 'bonfire-kindling';

import { useIframeLogin, getBonfireOpportunityPath } from '../../hooks/useIframeLogin';

// Followed projects are fetched from `bonfire-global-api`
// which have a different interface and response object compared
// to the submissions/contracts routes.
const formatFollowingRow = row => ({
  projectId: row.ProjectID,
  domain: row.Organization.Domain,
  organizationName: row.Organization.OrganizationName,
});

const getPathForRowType = (type, row) => {
  switch (type) {
    case 'wip':
    case 'submitted':
    case 'awarded':
    case 'missed':
      return `/submissions/${row.proposalId}`;
    case 'following':
      return getBonfireOpportunityPath(row.projectId);
    case 'contracts':
      return `/publicContracts/${row.id}`;
    default:
      throw new Error('Invalid type!');
  }
};

const DashboardDataTableLinkCell = ({ row, type }) => {
  const { t } = useTranslation();
  const { logInToOrganizationDomain, handleLoadGoToProjectIframe, iframeRef, iframeSrc } =
    useIframeLogin();

  const formattedRow = type === 'following' ? formatFollowingRow(row) : row;
  const path = getPathForRowType(type, formattedRow);

  return (
    <>
      <TextButton
        size="small"
        label={t('dashboard.data_table.view')}
        variant="outline"
        onClick={() => {
          logInToOrganizationDomain(`https://${formattedRow.domain}`, path);
        }}
      />
      {iframeSrc && (
        <iframe
          style={{ display: 'none' }}
          ref={iframeRef}
          src={iframeSrc}
          onLoad={handleLoadGoToProjectIframe}
          title={t('dashboard.organization_iframe_title', {
            organization: formattedRow.organizationName,
          })}
          aria-hidden="true"
        />
      )}
    </>
  );
};

export default DashboardDataTableLinkCell;
